import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class AtLeastOneTeamWithExposureMoreThanZeroValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const exposureSumOfPrimaryStack = stacking.getExposureSumOfCheckedTeamsByStackNumber(
            Const.NHL_TEAM_STACKING_FIRST_STACK,
        );
        const exposureSumOfSecondaryStack = stacking.getExposureSumOfCheckedTeamsByStackNumber(
            Const.NHL_TEAM_STACKING_SECOND_STACK,
        );
        const exposureSumOfThirdStack = stacking.getExposureSumOfCheckedTeamsByStackNumber(
            Const.NHL_TEAM_STACKING_THIRD_STACK,
        );

        if (!exposureSumOfPrimaryStack || !exposureSumOfSecondaryStack || !exposureSumOfThirdStack) {
            this.addError('Should be at least one team with exposure more than 0.');
        }
    }
}

export default AtLeastOneTeamWithExposureMoreThanZeroValidator;
